import { SAVE_AS_DRAFT_CONTACT_FORM_KEY } from 'legacy/lut/components/widgets/public/contactEditDialog/configs'
import { EMarket } from 'legacy/lut/configs/geo'
import { combineValidateRules } from 'legacy/lut/helpers/combineValidateRules'
import React, { memo } from 'react'

import { FormDropdown, FormInput } from 'cng-common/features/form'
import { isValidEmail } from 'core-components/library/validation'
import { Crud } from 'core/types/Crud'

import styles from './SaveAsDraftContact.module.scss'

interface IProps {
  country: string
  firstName: string
  lastName: string
  email: string
  preferredLanguage: string
  market: EMarket
  dropdownSources: { countries: Crud<any, any>; preferredLanguages: Crud<any, any> }
  isValidEmailDomain: (value: string) => Promise<string>
}

export const FormFields = memo(
  ({
    country,
    firstName,
    lastName,
    email,
    preferredLanguage,
    market,
    dropdownSources,
    isValidEmailDomain,
  }: IProps) => {
    const needPreferredLanguage = [EMarket.greaterAsia, EMarket.india].includes(market)

    return (
      <div className={styles.formFields}>
        <div className={styles.fieldWrapper}>
          <FormDropdown
            formKey={SAVE_AS_DRAFT_CONTACT_FORM_KEY}
            classes={{
              controlClasses: {
                popPaper: styles.dropdown__paper,
              },
            }}
            defaultValue={country}
            field={'country'}
            label={'Country'}
            source={dropdownSources.countries}
            caption={'name'}
            isStatic
            isRequired
          />
        </div>

        <div className={styles.fieldWrapper}>
          <FormInput
            defaultValue={firstName}
            field={'firstName'}
            label={'First Name'}
            formKey={SAVE_AS_DRAFT_CONTACT_FORM_KEY}
          />
        </div>

        <div className={styles.fieldWrapper}>
          <FormInput
            defaultValue={lastName}
            field={'lastName'}
            label={'Last Name'}
            formKey={SAVE_AS_DRAFT_CONTACT_FORM_KEY}
          />
        </div>

        <div className={styles.fieldWrapper}>
          <FormInput
            formKey={SAVE_AS_DRAFT_CONTACT_FORM_KEY}
            defaultValue={email}
            field={'email'}
            label={'Email'}
            onValidate={combineValidateRules([isValidEmail, isValidEmailDomain])}
            isRequired
          />
        </div>

        <FormDropdown
          classes={{
            controlClasses: {
              popPaper: styles.dropdown__paper,
            },
          }}
          formKey={SAVE_AS_DRAFT_CONTACT_FORM_KEY}
          field={'preferredLanguage'}
          source={dropdownSources.preferredLanguages}
          defaultValue={preferredLanguage}
          label={'Preferred Language'}
          caption={'name'}
          isVisible={needPreferredLanguage}
          isRequired={needPreferredLanguage}
        />
      </div>
    )
  }
)
